import { mediaQuery } from "shared/styles/mixins"
import styled, { css } from "styled-components"

import { ChatView } from "../constants"

// This pattern of an input element wrapped in a div is used here because input elements
// can behave oddly with respect to width, and so the parent element is controlling width.
export const ChatInputWrapper = styled.div<{ $uiView: ChatView }>`
  flex-grow: 1; // takes as much width as possible
  height: ${(props) => props.theme.input.height};
  margin: 0;
  padding: 8px 12px;

  border-width: ${(props) => props.theme.input.borderWidth};
  border-color: ${(props) => props.theme.input.borderColor};
  border-radius: ${(props) => props.theme.input.borderRadius};
  border-style: solid;

  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.text.default};
  font-size: ${(props) => props.theme.input.textSize};
  line-height: 1;
  ${(props) =>
    props.$uiView === ChatView.OVERLAY &&
    css`
      z-index: ${props.theme.zIndex.interactiveButton};
    `}

  &:focus-within {
    border-color: ${(props) => props.theme.input.borderFocus};
  }

  ${(props) =>
    props.$uiView === ChatView.OVERLAY &&
    css`
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);

      &:focus-within {
        border-color: ${props.theme.colors.white};
      }
    `}

  ${mediaQuery.mobileDevice} {
    height: ${(props) => props.theme.mobile.input.height};
  }
`

export const ChatTextInput = styled.input<{ $uiView: ChatView }>`
  background-color: transparent;
  width: 100%;
  height: 100%;
  border: none;
  font-size: ${(props) => props.theme.input.textSize};
  transition: all 100ms ease-in;
  text-overflow: ellipsis;
  color: ${(props) => props.theme.colors.dark};

  &::placeholder {
    opacity: 0.8;
  }

  &:focus,
  &:active {
    outline: none;
    &::placeholder {
      // because chrome doesn't support text-overflow: ellipsis when focused
      opacity: 0;
    }
  }

  &:invalid {
    outline: none;
    box-shadow: none;
  }
`
